import React from 'react';
import './App.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GoldDashboard from './pages/GoldDashboard';
import LoansDashboard from './pages/LoansDashboard';
import ReceiptsDashboard from './pages/ReceiptsDashboard';
import GoldPurchaseDashboard from './pages/GoldPurchaseDashboard';
import KassaDashboard from './pages/KassaDashboard';
import ModulePicker from './pages/ModulePicker';
import { useAuth } from './context/AuthContext';
import { useModule } from './context/ModuleContext';

function AppShell() {
  const { user, loading } = useAuth();
  const { activeModule } = useModule();
  if (loading) return null;
  if (!user) return <Login />;
  if (activeModule === 'custody') return <Dashboard />;
  if (activeModule === 'gold') return <GoldDashboard />;
  if (activeModule === 'loans') return <LoansDashboard />;
  if (activeModule === 'receipts') return <ReceiptsDashboard />;
  if (activeModule === 'gold_purchase') return <GoldPurchaseDashboard />;
  if (activeModule === 'kassa') return <KassaDashboard />;
  return <ModulePicker />;
}

export default function App() {
  return <AppShell />;
}
